import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'

import { OperatorDataState } from '@states/operator-data'

const ALLOWED_PATH_LIST = ['/notifications/chat']
const HEADER_OPERATOR_ID = 'Operator-Id'
const HEADER_LOCATION_ID = 'Location-Id'

export const operatorHeadersInterceptor: HttpInterceptorFn = (req, next) => {
	const operatorDataState = inject(OperatorDataState)
	const metadata = operatorDataState.metadata()

	if (!metadata || !ALLOWED_PATH_LIST.some(url => req.url.includes(url))) {
		return next(req)
	}

	const { operatorCompanyId, parkingLocationId } = metadata

	return next(
		req.clone({
			headers: req.headers
				.set(HEADER_OPERATOR_ID, String(operatorCompanyId))
				.set(HEADER_LOCATION_ID, String(parkingLocationId)),
		})
	)
}
